import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactHero = ({ onConsultationClick }) => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-steel-blue to-innovation-blue text-white py-20 lg:py-28">
      <div className="absolute inset-0 bg-black/10"></div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center mb-6">
            <div className="flex items-center justify-center w-16 h-16 bg-white/20 rounded-full backdrop-blur-sm">
              <Icon name="MessageSquare" size={32} color="white" strokeWidth={2} />
            </div>
          </div>
          
          <h1 className="text-4xl lg:text-6xl font-bold mb-6 leading-tight">
            Start Your AI
            <span className="block text-accent">Transformation Journey</span>
          </h1>
          
          <p className="text-xl lg:text-2xl text-white/90 mb-8 leading-relaxed">
            Connect with our enterprise AI architects for strategic consultation, technical assessment, or partnership opportunities. Multiple engagement pathways designed for your specific needs.
          </p>
          
          {/* Primary CTAs removed per request */}
        </div>
      </div>
    </section>
  );
};

export default ContactHero;